import React from 'react'
import PropTypes from 'prop-types'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap/lib/helpers/web_to_client'

import { UNIT_TYPES } from 'constants'
import { FORT_BATTLE, SORTIE_WITH_LEVEL } from 'helpers/i18n'
import { toRoman } from 'helpers'

import styles from './Unit.scss'

export const Unit = props => {
    const { maxVehicleLevel, commanderNickname, membersNumber, maxMembersNumber, type } = props

    const battleModeMessage = (type === UNIT_TYPES.SORTIE) ?
        SORTIE_WITH_LEVEL(toRoman(maxVehicleLevel)) :
        FORT_BATTLE

    return (
        <div
            className={styles.base}
            onClick={props.onClick}
            onMouseDown={sendClickSoundCommand}
            onMouseEnter={sendHoverSoundCommand}
        >
            <div className={styles.battleMode}>
                {battleModeMessage}
            </div>

            <div className={styles.commanderName}>
                {commanderNickname}
            </div>

            <div className={styles.counter}>
                <span className={styles.highlight}>
                    {membersNumber}
                </span>
                {' / '}
                {maxMembersNumber}
            </div>
            {props.isInBattle && <div className={styles.inBattle} />}
        </div>
    )
}

Unit.propTypes = {
    type: PropTypes.string.isRequired,
    maxVehicleLevel: PropTypes.number,
    commanderNickname: PropTypes.string.isRequired,
    membersNumber: PropTypes.number.isRequired,
    maxMembersNumber: PropTypes.number.isRequired,
    isInBattle: PropTypes.bool.isRequired,

    onClick: PropTypes.func.isRequired,
}

export default Unit



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Unit/Unit.jsx